module.exports = __webpack_public_path__ + "static/giraffe-cover-7a40c801cd1e5e4f9e45313e30341b50.png";